<template>
    <ui-container class="py-8 space-y-8" v-if="ppeRegister.id">
        <!-- Header. -->
        <ui-header :title="`PPE Register ${ppeRegister.formattedDate}`" :subtitle="'ID #'+this.ppeRegister.id">
            <template #actions>
                <ui-dropdown placement="bottom-end" menu-class="p-3 w-64">
                    <template #default="{ toggle }">
                        <ui-button-new @click="toggle" primary>
                            Actions
                            <i class="flex-shrink-0 ml-2 fa fa-chevron-down"></i>
                        </ui-button-new>
                    </template>
                    <template #menu="{ close }">
                        <ui-dropdown-item icon="fas fa-calculator"
                                          @click="edit()">
                            Edit
                        </ui-dropdown-item>
                        <ui-dropdown-divider v-if="!ppeRegister.locked"></ui-dropdown-divider>
                        <ui-dropdown-item v-if="!ppeRegister.locked" danger icon="fa fa-trash"
                                          @click="openDeleteModal">Delete
                        </ui-dropdown-item>
                    </template>
                </ui-dropdown>
            </template>
        </ui-header>
        <ui-data-grid>
            <ui-data-grid-item label="Date" :value="ppeRegister.formattedDate"></ui-data-grid-item>
        </ui-data-grid>
        <div class="space-y-0">
            <label class="py-0">People</label>
            <div class="flex mt-8 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                <div class="w-6 flex-shrink-0"></div>
                <div class="flex-1 border-l border-r border-gray-200 px-2 py-1" style="min-width: 55px;">Name</div>
                <element-size-sync ref="sync1" :other-elements="() => getPersonElementsFor('hardhat')">
                    <div class="border-r border-gray-200 p-0" style="min-width: 32px">
                        <rotate>
                            <autoresizable-input
                                measure="p-1 m-0 border-none text-xs font-semibold text-gray-500"
                                :min="32">
                                <page-cell name="name" value="Hard Hat" disabled
                                           class="border-none shadow-none bg-transparent text-xs text-gray-500 font-semibold p-1 m-0">
                                </page-cell>
                            </autoresizable-input>
                        </rotate>
                    </div>
                </element-size-sync>
                <element-size-sync ref="sync2" :other-elements="() => getPersonElementsFor('highVisibilityVest')">
                    <div class="border-r border-gray-200 p-0 " style="min-width: 32px">
                        <rotate>
                            <autoresizable-input
                                measure="p-1 m-0 border-none text-xs font-semibold text-gray-500"
                                :min="32">
                                <page-cell name="name" value="Hi-Vis" disabled
                                           class="border-none shadow-none bg-transparent text-xs text-gray-500 font-semibold p-1 m-0">
                                </page-cell>
                            </autoresizable-input>
                        </rotate>
                    </div>
                </element-size-sync>
                <element-size-sync ref="sync3" :other-elements="() => getPersonElementsFor('boots')">
                    <div class="border-r border-gray-200 p-0" style="min-width: 32px">
                        <rotate>
                            <autoresizable-input
                                measure="p-1 m-0 border-none text-xs font-semibold text-gray-500"
                                :min="32">
                                <page-cell name="name" value="Boots" disabled
                                           class="border-none shadow-none bg-transparent text-xs text-gray-500 font-semibold p-1 m-0">
                                </page-cell>
                            </autoresizable-input>
                        </rotate>
                    </div>
                </element-size-sync>
                <element-size-sync ref="sync4" :other-elements="() => getPersonElementsFor('goggles')">
                    <div class="border-r border-gray-200 p-0" style="min-width: 32px">
                        <rotate>
                            <autoresizable-input
                                measure="p-1 m-0 border-none text-xs font-semibold text-gray-500"
                                :min="32">
                                <page-cell name="name" value="Goggles" disabled
                                           class="border-none shadow-none bg-transparent text-xs text-gray-500 font-semibold p-1 m-0">
                                </page-cell>
                            </autoresizable-input>
                        </rotate>
                    </div>
                </element-size-sync>
                <element-size-sync ref="sync5" :other-elements="() => getPersonElementsFor('gloves')">
                    <div class="border-r border-gray-200 p-0" style="min-width: 32px">
                        <rotate>
                            <autoresizable-input
                                measure="p-1 m-0 border-none text-xs font-semibold text-gray-500"
                                :min="32">
                                <page-cell name="name" value="Gloves" disabled
                                           class="border-none shadow-none bg-transparent text-xs text-gray-500 font-semibold p-1 m-0">
                                </page-cell>
                            </autoresizable-input>
                        </rotate>
                    </div>
                </element-size-sync>
                <element-size-sync ref="sizesync" :other-elements="getPersonElements"
                                   v-for="(equipment) in ppeRegister.otherEquipment" :key="equipment.id">
                    <div class="border-r border-gray-200 p-0" style="min-width: 32px" ref="equipmentName">
                        <rotate>
                            <autoresizable-input :post-resize="resize"
                                                 measure="p-1 m-0 border-none text-xs font-semibold text-gray-500"
                                                 :min="32">
                                <page-cell name="name" v-model="equipment.name" disabled
                                           class="border-none shadow-none bg-transparent text-xs overflow-visible text-gray-500 font-semibold p-1 m-0">
                                </page-cell>
                            </autoresizable-input>
                        </rotate>
                    </div>
                </element-size-sync>
                <div class="w-20 border-r border-gray-200 px-2 py-1">Signature</div>
                <div class="w-6 flex-shrink-0 ml-2"></div>
            </div>
            <ppe-register-person v-for="(person,index) in ppeRegister.people"
                                 :key="person.id"
                                 :person="person"
                                 :ppe-register="ppeRegister"
                                 :readonly="true"
                                 :contacts="contacts"
                                 :other-equipment="ppeRegister.otherEquipment"
                                 ref="people"
            ></ppe-register-person>


        </div>
        <ui-data-grid>
            <ui-data-grid-item label="Given By" :value="ppeRegister.givenByName"></ui-data-grid-item>
            <ui-data-grid-item label="Position" :value="ppeRegister.givenByPosition"></ui-data-grid-item>
            <div class="lg:col-span-2">
                <dt class="text-sm font-medium text-gray-500">Signed</dt>
                <dd class="mt-1 text-sm text-gray-900 w-full">
                    <img v-if="ppeRegister.signature" :src="ppeRegister.signature" style="height:48px">
                    <div class="inline-block" v-else>
                        <ui-dropdown menu-class="p-3 w-56">
                            <template #default="{ toggle }">
                                <button @click="toggle"
                                        class="inline-block w-32 h-5 flex text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                                    <i class="fa fa-ellipsis-h fa-fw mt-0.5"></i>
                                    <span class="inline-block whitespace-pre-wrap text-red-600 ml-2">NOT Signed</span>
                                </button>
                            </template>
                            <template #menu="{ close }">
                                <ui-dropdown-item icon="fas fa-pencil" @click="addSignature();close();">Add Signature
                                </ui-dropdown-item>
                            </template>
                        </ui-dropdown>
                    </div>
                </dd>
            </div>
        </ui-data-grid>
        <send-log :send-log="combineSendLogs" @revoke="revoke" @resend="resend"></send-log>
        <ui-data-grid-item label="Quick action" wide>
            <div class="flex flex-col md:flex-row flex-wrap -m-2">
                <ui-button-new class="m-2" icon="fas fa-route" @click="duplicate" success>Duplicate
                </ui-button-new>
                <ui-button-new class="m-2" icon="fas fa-phone"
                               v-if="ppeRegister.people.some((i)=> !i.signature && !i.signatureRequestedAt)"
                               @click="requestAllSignatures" extra>Request Signatures
                </ui-button-new>
                <a :href="ppeRegister.getDownloadUrl()" tabindex="-1">
                    <ui-button-new class="m-2" icon="fas fa-file-pdf">Download PDF</ui-button-new>
                </a>
                <ui-button-new class="m-2" icon="fas fa-print" @click="print">Print PDF</ui-button-new>
                <ui-button-new class="m-2" icon="fas fa-route" extra
                               @click="send"
                >Send
                </ui-button-new>
            </div>
        </ui-data-grid-item>
        <ui-data-grid>
            <ui-data-grid-item label="Created By">{{ ppeRegister.createdBy }} on {{
                    ppeRegister.createdOn
                }}
            </ui-data-grid-item>
            <ui-data-grid-item label="Last Updated By" v-if="ppeRegister.lastUpdatedBy">{{ ppeRegister.lastUpdatedBy }}
                on {{
                    ppeRegister.lastUpdatedOn
                }}
            </ui-data-grid-item>
        </ui-data-grid>

    </ui-container>
</template>

<script>
import {PPERegister} from '@models'
import {uuid} from "../../../utils";
import AutoresizableInput from "../../ui/AutoresizableInput";
import PageCell from "../../ui/PageCell.vue";
import UiDataGrid from "../../ui/UiDataGrid.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiContainer from "../../ui/UiContainer.vue";
import UiHeader from "../../ui/UiHeader.vue";
import PpeRegisterPerson from "./PpeRegisterPerson.vue";
import ElementSizeSync from "../../ui/ElementSizeSync";
import Rotate from "../../ui/Rotate.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import SendLog from "../../send-log/SendLog.vue";
import moment from "moment/moment";

export default {
    components: {
        SendLog,
        UiDropdownDivider,
        UiDropdown,
        UiDropdownItem,
        Rotate,
        ElementSizeSync,
        PpeRegisterPerson,
        UiHeader, UiContainer, UiButtonNew, UiDataGridItem, UiDataGrid, PageCell, AutoresizableInput
    },
    props: {
        item: Object,
        edit: Function,
        removeItem: Function,
        addItem: Function,
        contacts: Array(),
        packageReference: null,
        packageName: null,
    },
    computed: {
        combineSendLogs() {
            return this.ppeRegister.sendLog.map((a) => {
                return a;
            }).concat(...this.ppeRegister.people.map((a) => a.sendLog ? a.sendLog.map((b) => {
                return b;
            }) : [])).sort((a, b) => moment(b.requested.at).unix() - moment(a.requested.at).unix())
        }
    },
    data() {
        return {
            ppeRegister: Object
        }
    },
    methods: {
        send() {
            this.$modals.open('ppe-register-send-modal', {
                title: `Send PPE Register`,
                button: 'Send PPE Register',
                ppeRegister: this.ppeRegister,
                handle: async (messageId, modal) => {
                    modal.close()
                }
            })
        },
        revoke(i) {
            this.ppeRegister.revoke(i.id);
        },
        resend(i) {
            this.ppeRegister.resend(i.id);
        },
        requestAllSignatures() {
            this.$modals.open('ppe-register-multiple-signature-request', {
                title: `Send signature request to all people not yet requested`,
                contacts: this.contacts,
                people: this.ppeRegister.people,
                handle: async (data, modal) => {
                    let requests = [];
                    data.forEach((i) => {
                        if (i.to) {
                            requests.push(this.ppeRegister.requestSignature(i.id, i.to))
                        }
                    })
                    await Promise.all(requests).then(async () => {
                        let ndb = await PPERegister.find(this.ppeRegister.packageReference, this.ppeRegister.id)
                        Object.assign(this.ppeRegister, ndb)
                        modal.close()
                    })
                }
            })
        },
        addSignature() {
            this.$modals.sign({
                title: `Sign as "${this.ppeRegister.givenByName}"`,
                button: 'Confirmed',
                handle: (data) => {
                    this.ppeRegister.signature = data.signature;
                    this.ppeRegister.update();
                }
            })
        },
        resize() {
            this.$nextTick(() => {
                this.$refs.sync1.resizeElements()
                this.$refs.sync2.resizeElements()
                this.$refs.sync3.resizeElements()
                this.$refs.sync4.resizeElements()
                this.$refs.sync5.resizeElements()
                this.$refs.sizesync ? this.$refs.sizesync.map((i) => i.resizeElements()) : false
            })
        },
        getPersonElementsFor(ref) {
            return this.$refs.people.map((i) => {
                return i.$refs[ref]
            })
        },
        getPersonElements(e) {
            if ((this.$refs.equipmentName) && (this.$refs.people)) {
                let index = this.$refs.equipmentName.findIndex((i) => i === e.$el);
                return this.$refs.people.map((i) => {
                    return i.$refs.otherEquipment[index]
                })
            }
            return [];
        },
        openDeleteModal() {
            const title = 'Are you sure you want to remove PPE Register ' + this.item.formatted_date + '?'
            const description = 'You are removing PPE Register #' + this.item.id + '. Are you sure you want to do this?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete()
                this.removeItem(this.item)

            });
        },
        async duplicate() {
            let data = this.ppeRegister.getFormAttributes();
            data.people.map((i) => {
                i.id = uuid(), i.signature = null
            })
            data.signature = null
            const ppeRegister = await PPERegister.create(this.packageReference, uuid(), data)

            this.addItem(ppeRegister, 0, (items) => {
                items.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0));
            });
            this.edit(ppeRegister);
        },
        print() {
            this.$emit('print', this.item.getPrintableUrl())
        },
        async updateFromListener(data) {
            if (data.operation === 'updateAggregate') {
                if ((data.aggregate.type === 'PPERegister') && (data.aggregate.id === this.ppeRegister.id)) {
                    Object.assign(this.ppeRegister, data.aggregate.data)
                    Object.assign(this.item, data.aggregate.data)
                }
            }
        },
    },
    async mounted() {
        this.ppeRegister = await PPERegister.find(this.packageReference, this.item.id)
        this.$nextTick(() => this.resize());
        if (this.ppeRegister) {
            User.registerAggregate({'type': 'PPERegister', 'id': this.ppeRegister.id}, this.updateFromListener)
        }

    }
}
</script>
